import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PageContainer, PageHeader } from "@fleet/ui";
import { AuthorEarnings } from "@/features/billing/components/author-earnings";
import { PlanOverview } from "@/features/billing/components/plan-overview";
import { useI18n } from "@/providers/i18n-provider";

/**
 * Plan/subscription screen (MONETIZATION_QUOTAS). URL-addressable:
 * /u/$u/profile/plan. With monetization OFF shows empty state
 * (the profile link does not even appear in that case).
 */
function ProfilePlanPage() {
  const { t } = useI18n();
  return (
    <PageContainer maxWidth="2xl">
      <PageHeader title={t(msg`Plan & usage`)} backTo="/profile" />
      <PlanOverview />
      {/* Reparto a autores: independiente del switch de monetización — si el
          autor tiene payouts, se muestran (si no, la tarjeta no aparece). */}
      <div class="mt-6">
        <AuthorEarnings />
      </div>
    </PageContainer>
  );
}

export const profilePlanRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/profile/plan",
  component: ProfilePlanPage,
});
